<template>
  <div>
    <v-layout row wrap class="mb-3">
      <v-flex xs12 class="mt-4 px-0">
        <h5 class="border-top font-weight-bold">
          Thợ sửa chữa {{ index + 1 }}
          <v-btn @click="removeRepairTimesheet(index)" color="red" flat small v-if="!repairTimesheetItemState._id"
            :disabled="loading.submit || (chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH || repairTimesheetItemState.status === REPAIR_TIMESHEET_STATUS.DA_CHI_TIEN) ">
            Xóa
            <v-icon>delete</v-icon>
          </v-btn>
        </h5>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field label="Mã chứng từ" v-model="repairTimesheetItemState.receipt_id" prepend-icon="account_box"
          disabled></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-autocomplete label="Số phòng"
          :disabled="loading.submit || (chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH || repairTimesheetItemState.status === REPAIR_TIMESHEET_STATUS.DA_CHI_TIEN) "
          v-model="repairTimesheetItemState.room_id" :items="room_ids" item-text="room_id" item-value="rooms_id"
          prepend-icon="meeting_room" :rules="[rules.required]" required></v-autocomplete>
      </v-flex>
      <v-flex v-if="repairTimesheetItemState.room_id === 'Khác'" xs12 md3>
        <v-text-field v-model="repairTimesheetItemState.customRoomId" label="Nhập số phòng" :rules="[rules.required]"
          required
          :disabled="loading.submit || (chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH || repairTimesheetItemState.status === REPAIR_TIMESHEET_STATUS.DA_CHI_TIEN) "></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-select label="Tên thợ sửa"
          :disabled="loading.submit || (chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH || repairTimesheetItemState.status === REPAIR_TIMESHEET_STATUS.DA_CHI_TIEN) "
          v-model="repairTimesheetItemState.repairman_name" :items="[...repairmen.map(repairman=>repairman.name), repairTimesheetItemState.repairman_name]"
          prepend-icon="account_box" :rules="[rules.required]" required></v-select>
      </v-flex>
      <v-flex xs12 md3>
        <v-menu :close-on-content-click="false" v-model="menu_completion_date" :nudge-right="40" lazy
          transition="scale-transition" offset-y full-width min-width="290px">
          <v-text-field slot="activator" v-model="repairTimesheetItemState.completion_date" label="Ngày hoàn thành"
            :disabled="loading.submit || (chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH || repairTimesheetItemState.status === REPAIR_TIMESHEET_STATUS.DA_CHI_TIEN) "
            prepend-icon="event" readonly :rules="[rules.required]"></v-text-field>
          <v-date-picker locale="vi-VI" v-model="repairTimesheetItemState.completion_date"
            @input="menu_completion_date = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field label="Thời gian hoàn thành"
          :disabled="loading.submit || (chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH || repairTimesheetItemState.status === REPAIR_TIMESHEET_STATUS.DA_CHI_TIEN) "
          v-model="repairTimesheetItemState.completion_time" prepend-icon="event" type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field label="Tiền công" v-model="repairTimesheetItemState.labor_cost" prepend-icon="money" disabled v-currency></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field label="Mua vật tư"
          :disabled="loading.submit || (chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH || repairTimesheetItemState.status === REPAIR_TIMESHEET_STATUS.DA_CHI_TIEN) "
          v-model="repairTimesheetItemState.material_purchased"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field label="Tiền vật tư"
          :disabled="loading.submit || (chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH || repairTimesheetItemState.status === REPAIR_TIMESHEET_STATUS.DA_CHI_TIEN) "
          v-model="repairTimesheetItemState.material_cost" prepend-icon="money" v-currency></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field label="Tổng phải thanh toán" disabled v-model="repairTimesheetItemState.total_payment"
          prepend-icon="money" :rules="[rules.required]" v-currency></v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {
  list_building,
  REPAIR_REQUEST_STATUS,
  REPAIR_TIMESHEET_STATUS
} from "Constants/db-config";
import {
  deepCopy,
  formatCurrency,
  parseCurrency,
  buildParamQuery
} from "Helpers";
import api from "Api";

export default {
  name: "cham-cong-item-trong-phieu-sua-chua",
  props: {
    index: Number,
    repairTimesheetItem: Object,
    totalRepairTimesheetIndex: Number,
    chosen_repair_request: Object,
    repairmen: Array
  },
  components: {},
  data() {
    return {
      menu_completion_date: false,
      loading: {
        submit: false,
      },
      formatCurrency,
      repairTimesheetItemState: deepCopy(this.repairTimesheetItem),
      list_building,
      rules: {
        required: (value) => !!value || "Vui lòng điền thông tin này.",
      },
      alert: {
        show: false,
        text: "",
        type: "error",
      },
      REPAIR_REQUEST_STATUS,
      parseCurrency,
      repairmen: [],
      REPAIR_TIMESHEET_STATUS
    };
  },
  computed: {
    rooms() {
      return this.$store.state.app.rooms;
    },
    room_ids() {
      return ["Khác", ...this.rooms.filter(
        (room) => room.building === this.chosen_repair_request.building
      )];
    },
  },
  watch: {
    repairTimesheetItem: {
      handler: function (nv) {
        this.repairTimesheetItemState = nv
      },
      deep: true
    },
    repairTimesheetItemState: {
      handler: function (nv) {
        this.$emit("setRepairTimesheetsState", nv, this.index)
      },
      deep: true
    },
    "repairTimesheetItemState.completion_time"(nv) {
      if (nv && this.repairTimesheetItemState.repairman_name) {
        const repairman = this.repairmen.find(item=>item.name===this.repairTimesheetItemState.repairman_name);
        const wage = repairman.daily_wage || 0;
        const cost = wage / repairman.daily_hours * nv / 60;
        this.repairTimesheetItemState.labor_cost = Math.round(cost / 1000) * 1000;
      } else {
        this.repairTimesheetItemState.labor_cost = 0;
      }
    },
    "repairTimesheetItemState.repairman_name"(nv) {
      if (nv && this.repairTimesheetItemState.completion_time) {
        const repairman = this.repairmen.find(item=>item.name===nv);
        const wage = repairman.daily_wage || 0;
        const cost = wage / repairman.daily_hours * this.repairTimesheetItemState.completion_time / 60;
        this.repairTimesheetItemState.labor_cost = Math.round(cost / 1000) * 1000;
      } else {
        this.repairTimesheetItemState.labor_cost = 0;
      }
    },
    "repairTimesheetItemState.material_cost"() {
      this.updateTotalPayment();
    },
    "repairTimesheetItemState.labor_cost"() {
      this.updateTotalPayment();
    },
  },
  methods: {
    clearInput: function () {
      this.$refs.repairTimesheetItemState.reset();
    },
    removeRepairTimesheet: function (index) {
      this.$emit("removeRepairTimesheet", index);
    },
    updateTotalPayment() {
      const material = this.repairTimesheetItemState.material_cost ? parseCurrency(this.repairTimesheetItemState.material_cost) : 0;
      const labor = this.repairTimesheetItemState.labor_cost ? parseCurrency(this.repairTimesheetItemState.labor_cost) : 0;

      this.repairTimesheetItemState.total_payment = Math.round((material + labor) / 1000) * 1000;
    },
  },
};
</script>

<style scoped>
.border-top {
  padding-top: 9px;
  border-top: 1px solid #ddd;
}

.layout .flex {
  padding: 8px
}
</style>
